export default {
    add_booth: '手动添加新增展位',
    search_text: '请输入您想要搜索的内容',
    special_booth: '特装',
    standard_booth: '标摊',
    add_shopcart: '加入租赁清单',
    add_food_shopcart: '加入餐饮清单',
    lease_list: '租赁清单',
    go_settlement: '去结算',
    total_amount: '总计',
    foregift_title: '押金：',
    price_title: '租金：',
    specifications_title: '规格：',
    buyNum_title: '数量：',
    description_title: '描述：',
    all: '全部',
    no_message: '当前分类下暂无商品可租赁，请联系主场配置',
    shopName: '商品租赁',
    drawText: '图文详情',
    baseinfo: '基本信息',
    shopdetailname: '品名',
    color: '颜色',
    texture: '材质',
    unit: '单位',
    '返回商品列表':'返回商品列表',
    '提示':'',
    '展位':'展位:',
    '参展商':'参展商:',
    '是':'是',
    '不是':'不是',
    '库存不足':'库存不足， 请减少购买数量',
    '选中的展位':'选中的展位:',
    '是您的展位吗':'是您的展位吗?',
    '绑定展位成功':'绑定展位成功',
    '至少选择一个展位进行添加':'至少选择一个展位进行添加',
    '您没有添加展位':'您没有添加展位，请添加展位后选择商品',
    '类型':'类型',
    '首页':'首页',
    '租赁商品列表':'租赁商品列表',
    '添加展位':'添加展位',
    '全部':'全部',
    '搜索':'搜索',
    '件商品':'件商品',
    '收起':'收起',
    '展开':'展开',
    '删除':'删除',
    '总结': '总计',
    '去结算':'去结算',
    '单价':'单价',
    '含押金':'含押金',
    '租赁清单空空的~':'租赁清单空空的~',
    '更多':'更多',
    '请先选择商品需要派送的展位，再进行下单':'请先选择商品需要派送的展位，再进行下单',
    '租赁服务':'租赁服务',
    '暂无可添加展位':'暂无可添加展位'
    // '件商品':'',
  }



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/shopList.js